import { useState, useEffect } from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { Box, List, ListItem, ListItemButton, Paper, TextField, Typography } from "@mui/material";

export function AddressSearchField({ value, onChange, onSelect }) {
  return (
    <PlacesAutocomplete value={value || ""} onChange={onChange} onSelect={onSelect} shouldFetchSuggestions={value?.length > 2}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <Box sx={{ position: "relative" }}>
          <TextField
            {...getInputProps({})}
            fullWidth
            variant="standard"
            size="small"
            placeholder="Search address..."
            InputProps={{ sx: { fontSize: "0.8rem" } }}
          />

          {suggestions.length > 0 && (
            <Paper
              elevation={6}
              sx={{
                position: "absolute",
                zIndex: 10,
                width: "100%",
                mt: 1,
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <List dense disablePadding>
                {loading && (
                  <ListItemButton disabled>
                    <Typography variant="caption">Searching...</Typography>
                  </ListItemButton>
                )}

                {suggestions.map((suggestion) => (
                  <ListItemButton
                    key={suggestion.placeId}
                    {...getSuggestionItemProps(suggestion)}
                    sx={{
                      fontSize: "0.8rem",
                      py: 1,
                    }}
                  >
                    {suggestion.description}
                  </ListItemButton>
                ))}
              </List>
            </Paper>
          )}
        </Box>
      )}
    </PlacesAutocomplete>
  );
}
